import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)
let iso = ''

const parent = $('.pt-activities__posts')
if (parent.length) {
  iso = new Isotope('.pt-activities__posts', {
    itemSelector: '.feed-activity',
    percentPosition: true,
    masonry: {
      columnWidth: '.pt-activities__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })
}

const input = $('.pt-activities .filters input')

input.on('change', function () {
  // Terms checkbox.
  const booking = document.querySelectorAll('.booking-term')
  let bookingIds = []
  if (booking) {
    ;[...booking].map((booking) => {
      booking.checked && bookingIds.push(booking.value)
    })
    bookingIds = bookingIds.map(Number)
  }

  // Terms radio.
  const capacity = $('input[name="capacity"]:checked').val() * 1
  const ages = $('input[name="age"]:checked').val() * 1

  iso.arrange({
    filter: function () {
      const post = $(this)

      if (post.hasClass('pt-locations__sizer')) {
        return false
      }

      let bookingMatched = false
      let bookings = post.attr('data-bookings')
      bookings = bookings.includes(',') ? bookings.split(',') : [bookings]
      bookings = bookings.map(Number)
      if (bookingIds.length) {
        for (let el of bookingIds) {
          if (bookings.includes(el)) {
            bookingMatched = true
            break
          }
        }
      }

      let capsMatched = true
      let caps = post.attr('data-capacities')
      if (capacity) {
        if ( capacity > caps ) {
          capsMatched = false
        }
      }

      let ageMatched = true
      let age = post.attr('data-ages')
      age = age.includes(',') ? age.split(',') : [age]
      age = age.map(Number)
      if (ages) {
        ageMatched = age.includes(ages)
      }

      return bookingMatched && capsMatched && ageMatched
    },
  })
})

const search = $('.pt-activities .filters input[type="search"]').keyup(
  debounce(function () {
    const qsRegex = new RegExp(search.val(), 'gi')

    iso.arrange({
      filter: function () {
        const post = $(this)
        const text = getTextNodesIn(post[0])

        return qsRegex ? text.match(qsRegex) : true
      },
    })
  }, 200)
)
